module.exports = __webpack_public_path__ + "img/fd303f4.png";